<template>
	<ul class="main-menu">

		<template v-for="menux in menus">
			<li class="sub-header">{{ menux.header }}</li>
			<li class="has-sub-menu" v-for="menu in menux.menus"
			    v-on:click="openMenu(menu)"
			    v-on:mouseover="(w >= 1200) ? menu.active = true : ''"
			    v-on:mouseleave="(w >= 1200) ? menu.active = false : ''"
			    :class="(menu.active) ? 'active' : ''">
				<a :href="(menu.sub) ? 'javascript:void()' : '/#/'+menu.route" :class="(!menu.sub) ? 'docka' : ''">
					<div class="icon-w">
						<i :class="menu.icon"></i>
					</div>
					<span class="capitalize">{{ menu.title }}</span>
				</a>
				<div class="sub-menu-w" v-if="menu.sub" >
					<div class="sub-menu-header">
						{{ menu.title }}
					</div>
					<div class="sub-menu-icon">
						<i :class="menu.icon"></i>
					</div>
					<div class="sub-menu-i">
						<ul class="sub-menu capitalize">
							<li v-for="(index, sub) in menu.sub">
								<a :href="'/#/'+index.route" class="docka">{{ index.title }}</a>
							</li>
						</ul>
					</div>
				</div>
			</li>
		</template>
		<li>
			<div class="mt-4">
				<div class="pull-left">
					{{ t.dark_mode }}
				</div>
				<div id="toggles" class="pull-right">
					<input type="checkbox" id="darkmode__" v-model="darkMode" name="darkmode__" value="1" class="ios-toggle">
					<label for="darkmode__" class="checkbox-label"></label>
				</div>
			</div>
		</li>
	</ul>
</template>

<script>

    export default {
        name: 'dock',
        data () {
            return {
                w: window.innerWidth,
	            darkMode: false,
                t: this.$root.t,
                active: false,
	            userRole: null,
                menus: [
	                {
	                    header: '',
		                menus:
		                    [
                                {route: '', title: 'Dashboard', icon: 'os-icon os-icon-grid-circles', active: false },
                                {route: 'app', title: 'Applications', icon: 'os-icon os-icon-delivery-box-2', active: false },
                                {route: '', title: this.$root.t.users, icon: 'icon-user', active: false,
                                    sub: [
                                        { route: 'user?group[]=5', title: 'Risk Manager', icon: 'tx' },
                                        { route: 'user?group[]=5', title: 'Bookmaker', icon: 'tx' },
                                        { route: 'user?group[]=9', title: this.$root.t.user.groups.ROLE_OPERATOR, icon: 'tx' },
                                        { route: 'user?group[]=8', title: this.$root.t.user.groups.ROLE_PERSONAL, icon: 'tx' },
                                        { route: 'user?group[]=2', title: this.$root.t.user.groups.ROLE_ADMIN, icon: 'tx' },
                                        { route: 'user', title: this.$root.t.show_all, icon: 'tx' },
                                    ]
                                },
                                {route: 'user?group[]=5', title: this.$root.t.clients, icon: 'icon-people', active: false},
                                {route: '', title: this.$root.t.navigation.roles_and, icon: 'os-icon os-icon-crown', active: false,
                                    sub: [
                                        { route: 'roles/roles', title: this.$root.t.navigation.roles, icon: 'tx' },
                                        { route: 'roles/permissions', title: this.$root.t.navigation.permissions, icon: 'tx' }
                                    ]
                                },
                                {route: '', title: this.$root.t.sessions, route: 'sessions', icon: 'fa fa-clock-o', active: false},
                                {route: '', title: this.$root.t.navigation.reports, route: 'reports', icon: 'os-icon os-icon-newspaper', active: false},
                                {route: '', title: this.$root.t.navigation.analytics, icon: 'os-icon os-icon-bar-chart-stats-up', active: false,
                                    sub: [
                                        { route: 'analytics/session', title: this.$root.t.navigation.session_analytics, icon: 'tx' },
                                        { route: '', title: this.$root.t.navigation.action_analytics, icon: 'tx' }
                                    ]
                                },
                                {route: '', title: this.$root.t.navigation.accounting, icon: 'os-icon os-icon-coins-4', active: false,
                                    sub: [
                                        { route: 'deposit-accounts', title: this.$root.t.navigation.deposit_accounts, icon: 'tx' },
                                        { route: 'transactions', title: this.$root.t.navigation.transactions, icon: 'tx' },
                                        { route: 'orders', title: this.$root.t.navigation.orders, icon: 'tx' },
                                        { route: 'credits', title: this.$root.t.navigation.credits, icon: 'tx' },
                                        { route: 'receipts', title: this.$root.t.navigation.receipts, icon: 'tx' },
                                        { route: 'configuration/transactions-limitations', title: this.$root.t.navigation.transactions_limitations, icon: 'tx' },
                                        { route: 'payment-methods', title: this.$root.t.navigation.payment_methods, icon: 'icon-credit-card'}

                                    ]
                                },
                                {route: '', title: this.$root.t.navigation.system_preferences, icon: 'icon-globe', active: false,
                                    sub: [
                                        { route: 'configuration/system', title: this.$root.t.navigation.system_settings, icon: 'tx' },
                                       // { route: 'configuration/domain-names', title: this.$root.t.navigation.domain_names, icon: 'tx' },
                                        { route: 'configuration/company', title: this.$root.t.navigation.company_info, icon: 'tx' },
                                        { route: 'configuration/user-agreement', title: this.$root.t.navigation.user_agreement, icon: 'tx' },
                                        { route: 'configuration/privacy-policy', title: this.$root.t.navigation.privacy_policy, icon: 'tx' },
                                    ]
                                },
		                    ]
	                },
	                {
                        header: this.$root.t.navigation.sportsbook,
                        menus:
                            [
                            {route: 'fixture/configuration', title: this.$root.t.navigation.risk_management, icon: 'icon-settings', active: false, active: false, hint: this.$root.tinfo['SPORTSBOOK_CONF'],
                                    sub: [
                                        {route: 'configuration/bet-slip-stake-limitations', title: this.$root.t.navigation.bet_slip_limits, icon: '', active: false },
                                        {route: 'configuration/market-limitations', title: this.$root.t.navigation.market_limitations, icon: '', active: false },
                                        {route: 'configuration/market-ladder', title: this.$root.t.navigation.market_ladder, icon: '', active: false },
                                    ]
                                },

                                {route: '', title: this.$root.t.navigation.sport_bets, icon: 'icon-calculator', active: false,
                                    sub: [
                                        {route: 'bets', title: this.$root.t.bet_list, icon: '', active: false },
                                        {route: 'unsolved-bets', title: this.$root.t.unsolved_bets || 'Unsolved Results', icon: '', active: false },
	                                    {route: 'report/bet-match?period=today', title: this.$root.t.navigation.match_trends, icon: '', active: false },
                                        {route: 'report/bet-market?period=today', title: this.$root.t.navigation.bet_trends, icon: '', active: false },
                                        {route: 'report/competition-match?period=today', title: this.$root.t.navigation.competition_trends, icon: '', active: false },
                                        {route: 'report/sport-match?period=today', title: this.$root.t.navigation.sport_trends, icon: '', active: false },
                                        {route: 'report/bet-user-rewards?period=today', title: this.$root.t.navigation.bet_award_history, icon: '', active: false },
                                    ]
                                },
                                {route: '', title: this.$root.t.navigation.fixture, icon: 'icon-calendar', active: false,
                                    sub: [
                                        {route: 'genius/matching', title: 'Genius Matching', icon: 'os-icon os-icon-grid-circles', active: false },
                                        {route: 'fixture', title: this.$root.t.navigation.matches, icon: 'os-icon os-icon-grid-circles', active: false },
                                        {route: 'fixture?isLive=1', title: this.$root.t.sportsbook.filter.today, icon: '', active: false },
                                        {route: 'fixture?isLive=1', title: this.$root.t.sportsbook.filter.tomorrow, icon: 'os-icon os-icon-grid-circles', active: false },
                                        {route: 'fixture?isLive=1', title: this.$root.t.sportsbook.filter.upcoming, icon: 'os-icon os-icon-grid-circles', active: false },
                                        {route: 'fixture?isLive=1&allTime=true', title: this.$root.t.sportsbook.filter.all_time, icon: '', active: false },
                                    ]
                                },
                                {route: '', title: this.$root.t.navigation.live_fixture, icon: 'icon-fire', active: false,
                                    sub: [
                                        {route: 'fixture?onLive=1', title: this.$root.t.sportsbook.filter.playing, icon: '', active: false },
                                        {route: 'fixture?isLive=1', title: this.$root.t.sportsbook.filter.today, icon: '', active: false },
                                        {route: 'fixture?isLive=1', title: this.$root.t.sportsbook.filter.tomorrow, icon: 'os-icon os-icon-grid-circles', active: false },
                                        {route: 'fixture?isLive=1', title: this.$root.t.sportsbook.filter.upcoming, icon: 'os-icon os-icon-grid-circles', active: false },
                                        {route: 'fixture?isLive=1&allTime=true', title: this.$root.t.sportsbook.filter.all_time, icon: '', active: false },
                                    ]
                                },
                              {route: 'competition', title: this.$root.t.navigation.competition, icon: 'icon-globe-alt', active: false },
                              {route: 'class', title: this.$root.t.navigation.class, icon: 'os-icon os-icon-award', active: false },
                              {route: 'market', title: this.$root.t.navigation.market, icon: 'icon-book-open', active: false },
                              {route: 'sports', title: this.$root.t.navigation.sport, icon: 'fa fa-eercast', active: false },
                            ]
                    },
                  {
                    header: this.$root.t.navigation.casino,
                    menus: [
                      {route: 'casino/games', title: this.$root.t.navigation.games, icon: 'ti-game', active: false},
                      {route: 'casino/categories', title: this.$root.t.navigation.categories, icon: 'ti-view-list-alt', active: false},
                      {route: 'casino/providers', title: this.$root.t.navigation.providers, icon: 'ti-package', active: false},
                    ]
                  },
                  {
                    header: 'System',
                    menus: [
                      {route: 'system/translations', title: 'Translations', icon: 'ti-game', active: false},
                    ]
                  }
                ]
            }
        },
	    watch: {
            'darkMode' (o,n) {
                this.$bus.$emit('darkMode', this.darkMode)
            }
	    },
	    mounted () {
			var self = this;
            this.$getItem('darkMode', function (key, value) {
                //console.log all the kay/value pairs
                self.darkMode = value;
                self.$root.darkMode = value;

            }, function (err) {

            })
	    },
        methods: {
            openMenu (menu) {
                if (menu.active == false) {
                    menu.active = true;
                } else {
                    menu.active = false;
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/dock.vue